import _ from 'lodash';

import AgentConverter from 'scripts/application/dto_converters/agent_converter';
import AgentProfileConverter from 'scripts/application/dto_converters/agent_profile_converter';
import { getDatabase } from 'scripts/infrastructure/backends/fake_backend/database';

export default class AgentService {
  constructor(pubsub, database = getDatabase) {
    this._pubsub = pubsub;
    this.getDatabase = database;
  }

  findAllAgents(requestorId, orgId) {
    return this.getDatabase(orgId).agents;
  }

  findAllAgentProfiles(orgId) {
    return this.getDatabase(orgId).agentProfiles;
  }

  findAgentProfile(orgId, agentId) {
    return _.find(this.getDatabase(orgId).agentProfiles, { id: agentId });
  }

  add(requestorId, orgId, { correlationId, payload }) {
    let agentProfileDto = payload;
    this.getDatabase(orgId).agentProfiles.push(agentProfileDto);
    this._pubsub.publish(`v3/orgs/${orgId}/agent-profiles/${agentProfileDto.id}`, {
      payload: agentProfileDto,
    });
    this._pubsub.publish(`v3/requestor/${requestorId}/orgs/${orgId}/agent-profiles`, {
      correlationId,
      status: 'success',
    });

    // agent
    let agentProfileEntity = AgentProfileConverter.fromDto(agentProfileDto);
    let agentEntity = agentProfileEntity.toAgent();
    let agentDto = AgentConverter.toDto(agentEntity);
    this.getDatabase(orgId).agents.push(agentDto);
    this._pubsub.publish(`v1/orgs/${orgId}/agents/${agentDto.id}`, { payload: agentDto });
  }

  update(orgId, agentId, { correlationId, payload }) {
    // agent Profile
    let agentProfile = _.find(this.getDatabase(orgId).agentProfiles, { id: agentId });
    _.merge(agentProfile, payload);
    if (payload.voiceConfiguration) {
      agentProfile.voiceConfiguration = payload.voiceConfiguration;
    }
    this._pubsub.publish(`v3/orgs/${orgId}/agent-profiles/${agentId}`, { payload: agentProfile });

    // agent
    let agentProfileEntity = AgentProfileConverter.fromDto(agentProfile);
    let agentEntity = agentProfileEntity.toAgent();
    let agentDto = AgentConverter.toDto(agentEntity);
    let currentAgent = _.find(this.getDatabase(orgId).agents, { id: agentId });
    _.merge(currentAgent, agentDto);
    this._pubsub.publish(`v1/orgs/${orgId}/agents/${agentDto.id}`, { payload: agentDto });
  }
}



// WEBPACK FOOTER //
// ./src/scripts/infrastructure/backends/fake_backend/agent_service.js